import React from "react";
import ListEditor from "../ListEditor";
import { adminApi } from "../../lib/api";
import { Label, TextInput, NumberInput, Switch } from "../FormControls";

const newAch = () => ({
  title: "",
  detail: "",
  platform: "",
  url: "",
  visible: true,
  order: 0,
});

const Achievements = () => (
  <ListEditor
    resource={adminApi.achievements}
    resourceKey="achievements"
    title="Achievements"
    newItem={newAch}
    searchFields={["title", "platform"]}
    renderRow={(a) => (
      <div className="min-w-0">
        <div className="text-white font-medium truncate">{a.title}</div>
        <div className="text-xs text-slate-500 truncate">{a.detail} · {a.platform}</div>
      </div>
    )}
    renderForm={(d, set) => (
      <>
        <div>
          <Label>Title</Label>
          <TextInput value={d.title} onChange={(v) => set("title", v)} />
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>Platform</Label>
            <TextInput value={d.platform} onChange={(v) => set("platform", v)} placeholder="LeetCode" />
          </div>
          <div>
            <Label>URL (optional)</Label>
            <TextInput value={d.url} onChange={(v) => set("url", v)} placeholder="https://..." />
          </div>
        </div>
        <div>
          <Label>Detail</Label>
          <TextInput value={d.detail} onChange={(v) => set("detail", v)} />
        </div>
        <div className="flex items-center gap-6">
          <Switch value={d.visible} onChange={(v) => set("visible", v)} label="Visible" />
          <div className="flex items-center gap-2 ml-auto">
            <Label>Order</Label>
            <NumberInput value={d.order} onChange={(v) => set("order", v)} />
          </div>
        </div>
      </>
    )}
  />
);

export default Achievements;
